var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 68,
    viewBox: "0 0 75 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Highlight_05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70189 22.4259C7.49789 16.0259 8.40389 9.32534 9.23389 2.82534C9.40789 1.42534 8.43689 0.125535 7.06889 0.0255345C5.69989 -0.174466 4.44789 0.82612 4.27389 2.12612C3.47489 8.42612 2.6199 14.9255 0.890899 21.0255C0.515899 22.3255 1.28789 23.7261 2.61589 24.1261C3.94289 24.5261 5.32589 23.7259 5.70189 22.4259Z",
    fill: "#1B1C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1649 41.8251C41.6759 31.5251 50.8339 19.9251 61.6269 9.8251C62.6349 8.9251 62.6889 7.3251 61.7479 6.3251C60.8059 5.3251 59.2219 5.22549 58.2139 6.22549C47.3899 16.3255 38.2019 27.9255 27.6599 38.2255C26.6759 39.2255 26.6619 40.8251 27.6299 41.8251C28.5969 42.7251 30.1809 42.8251 31.1649 41.8251Z",
    fill: "#1B1C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5939 61.1264C65.5779 61.4264 59.5619 61.7259 53.5449 62.0259C52.1669 62.0259 51.1029 63.2264 51.1699 64.6264C51.2379 66.0264 52.4109 67.0259 53.7899 67.0259C59.8159 66.7259 65.8409 66.4264 71.8659 66.1264C73.2439 66.0264 74.3009 64.8262 74.2259 63.4262C74.1509 62.1262 72.9709 61.0264 71.5939 61.1264Z",
    fill: "#1B1C37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.49c2efe46656d4dbfd0a33ca22e7c8e1.svg";
export { ForwardRef as ReactComponent };